import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { QwickApp, ProductLogo } from '@qwickapps/react-framework';
import { DocumentProvider } from './contexts/DocumentContext';
import EditorPage from './pages/EditorPage';
import TermsPage from './pages/TermsPage';
import PrivacyPage from './pages/PrivacyPage';
import { AppFooter } from './components/AppFooter';
import './styles/print.css';
import packageJson from '../package.json';

const LogoWithNavigation: React.FC = () => {
  return (
    <a href="/" style={{ textDecoration: 'none', color: 'inherit', cursor: 'pointer', display: 'flex', alignItems: 'center' }}>
      <ProductLogo name="wick PDF" size="small" />
    </a>
  );
};

const App: React.FC = () => {
  return (
    <QwickApp
      appName="QwickPDF"
      appId="qwickpdf"
      logo={<LogoWithNavigation />}
      defaultTheme="light"
      defaultPalette="ocean"
      showThemeSwitcher={false}
      showPaletteSwitcher={true}
      enableScaffolding={true}
    >
      <BrowserRouter>
        <Routes>
          <Route
            path="/"
            element={
              <DocumentProvider>
                <EditorPage />
              </DocumentProvider>
            }
          />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
        </Routes>
        <AppFooter version={packageJson.version} />
      </BrowserRouter>
    </QwickApp>
  );
};

export default App;
